export default {
  API_BASE_URL: 'https://api.slt-dev.attrecto-dev.com/api',
  STORAGE_BASE_URL: 'https://app.slt-dev.attrecto-dev.com',
  ADMIN_URL: 'https://admin.slt-dev.attrecto-dev.com',
  RAZZLE_REMOTE_DEBUG: true,
  PRIVACY_POLICY: 'https://admin.slt-dev.attrecto-dev.com/privacy-policy',
  TERMS_AND_CONDITIONS: 'https://admin.slt-dev.attrecto-dev.com/terms-and-conditions',
};
